import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL || '/api/v1';

export interface PetalFallHistoryEntry {
  date: string;
  recordedAt: string;
  recordedBy: string;
}

export interface PhenologyData {
  activePetalFallDate: string | null;
  petalFallHistory: PetalFallHistoryEntry[];
}

export interface RecordPetalFallResponse {
  activePetalFallDate: string;
  previousDate: string | null;
  petalFallHistory: PetalFallHistoryEntry[];
}

/**
 * Fetch phenology data for an orchard.
 */
export const getPhenologyData = async (orchardId: string): Promise<PhenologyData> => {
  const response = await axios.get(`${baseUrl}/phenology/${orchardId}`, {
    withCredentials: true,
  });
  return response.data;
};

/**
 * Record an 80% petal fall date for an orchard.
 * Returns the previous date (if any) for comparison confirmation.
 */
export const recordPetalFallDate = async (
  orchardId: string,
  date: string
): Promise<RecordPetalFallResponse> => {
  const response = await axios.post(
    `${baseUrl}/phenology/${orchardId}/petal-fall`,
    { date },
    { withCredentials: true }
  );
  return response.data;
};
